<template>
  <v-form v-model="valid" ref="DialogForm">
    <slotted-dialog :title="$t('servicesystem.common_objects.machine.change_modelinfo_title')"
      :externaltrigger="dialogtrigger" :externalCloseTrigger="closetrigger">

      <template v-slot:content>
        <v-container :key="dialogtrigger" class="pb-6">
          <v-row v-if="machine && machine.Id">
            <v-col>
              <MachineSelect :value="machine" returnobject disabled>
              </MachineSelect>
            </v-col>
          </v-row>
          <v-row v-if="!disableFiltersOnModelSelect">
            <v-col class="pt-0 pb-2">
              <v-card class="py-2 px-3" flat style="border: 1px solid var(--v-primary-base)">
                <v-row no-gutters>
                  <v-col cols="auto" class="d-flex align-center justify-center flex-column">
                    <v-icon size="20" color="primary">mdi-information</v-icon>
                    <b class="primary--text mb-0">{{ $t('servicesystem.common_objects.commonterms.tip') }}</b>
                  </v-col>
                  <v-divider class="mx-3" vertical></v-divider>
                  <v-col cols="0">
                    <p class="mb-0 primary--text"
                      v-html="$t('servicesystem.common_objects.machine.change_modelinfo_tip')">
                    </p>
                  </v-col>
                </v-row>
              </v-card>
            </v-col>
          </v-row>

          <v-row>
            <v-col class="pa-1">
              <MachineProductEditContent :editItem="editItem" :editMode="true" :handleFocus="() => { }">
              </MachineProductEditContent>
            </v-col>
          </v-row>

          </v-container>
      </template>

      <template v-slot:buttons>
        <v-btn @click=" closetrigger++" color="primary" outlined
          v-text="$t('servicesystem.common_objects.commonterms.cancel')">
        </v-btn>
        <v-btn @click="valid ? save() : null" :disabled="!valid" :color="valid ? 'tertiary' : 'disabled'" dark>{{
          $t('servicesystem.common_objects.commonterms.save') }}</v-btn>
      </template>
    </slotted-dialog>
  </v-form>
</template>


<script>
import clientAPI from "@/api/ClientAPIMixin.js";
import MachineSelect from "@/components/Inputs/EntityDropdowns/MachineSelect2.vue";
import MachineProductEditContent from "@/views/admin/machines/MachineProductEditContent.vue";
import SlottedDialog from "@/views/layouts/SlottedDialog.vue";

export default {
  name: "ChangeModelInfoDialog",
  props: {
    externaltrigger: Number,
    machine: Object,
    saveFunction: {
      type: Function,
      required: true,
    },
  },
  components: {
    SlottedDialog,
    MachineSelect,
    MachineProductEditContent,
  },
  mixins: [clientAPI],

  data() {
    return {
      dialogtrigger: 0,
      closetrigger: 0,
      editItem: {},
      valid: false,
      loading: false,
    };
  },

  mounted() {
    this.parseItem();
  },

  methods: {
    async save() {
      this.loading = true;
      await this.saveFunction(this.editItem)
        .then(() => {
          this.closetrigger++;
        })
        .catch(() => { })
        .finally(() => {
          this.loading = false;
        });
    },

    parseItem() {
      this.editItem = Object.assign({}, this.machine);
    }
  },

  computed: {
    disableFiltersOnModelSelect() {
      return this.$store.state.GlobalSettings.DisableFiltersOnModelSelect;
    },
  },

  watch: {
    machine: {
      deep: true,
      handler() {
        this.parseItem();
      },
    },

    externaltrigger: function () {
      this.dialogtrigger++;
      this.parseItem();
    },
  },
};
</script>